import axios from "axios";
import { BACKEND_URL } from "../constants";

export const addEmployeesToProjectFromShift = async ({employees, project, user, company}) => {

    console.log("here")
    if (!employees || !project || !user || !company) {
        console.log("not all data recieved");

        return {
            status: "error",
            errorText: "Missing required data"
        };
    }

    console.log(employees, project, user, company)

    const { data } = await axios.post(`${BACKEND_URL}/add-employees-to-project-from-shift-page`, {
        userId: user._id,
        companyId: company._id,
        projectId: project,
        employees: employees
    }, { withCredentials: true})

    return data
}
